module.exports = __webpack_public_path__ + "img/about-3.54e4427.jpg";